module.exports = __webpack_public_path__ + "linkedin_logo.9b6066c63b33e3fbd53a536fc6600360.png";